import React from 'react';

import withPageComponents from '../../page/components/with-page-components';

export default withPageComponents(
    ({ srpSettings }) => {
        const { surveyContainerID } = srpSettings || {};
        if (!surveyContainerID) {
            return null;
        }
        return <div id={surveyContainerID} className="search-survey-container" />;
    },
    {
        components: ['srpSettings'],
    },
);
